import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { BauenLogoFull } from "@/components/BauenLogo";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Se o e-mail existir, um link foi enviado");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao processar solicitação");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background" data-testid="forgot-password-page">
      <div className="w-full max-w-md animate-fade-in-up">
        <BauenLogoFull className="mb-8" />
        <h2 className="font-heading text-2xl font-semibold">Recuperar senha</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Digite o e-mail da sua conta. Enviaremos um link para redefinir sua senha.
        </p>

        {!sent ? (
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div className="space-y-2">
              <Label htmlFor="fp-email">E-mail</Label>
              <Input id="fp-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email-input" placeholder="voce@empresa.com" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11" data-testid="forgot-submit-btn">
              {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Enviando…</> : "Enviar link"}
            </Button>
          </form>
        ) : (
          <div className="mt-8 p-4 rounded-xl border border-primary/20 bg-primary/5 text-sm" data-testid="forgot-success-msg">
            Se o e-mail informado estiver cadastrado, você receberá um link de recuperação em instantes.
          </div>
        )}

        <Link to="/login" className="mt-6 inline-flex items-center text-sm text-primary hover:underline" data-testid="back-to-login-link">
          <ArrowLeft className="mr-1 h-4 w-4" /> Voltar ao login
        </Link>
      </div>
    </div>
  );
}
